module.exports = __webpack_public_path__ + "img/map-marker-green.69cba4ee.svg";